<template>
  <div id="app" @scroll="check_header_fix()" :class="'rtl ' + (show_side_menu ? 'menu_open' : '')">
    
    <div id="side_menu" v-if="is_mobile()" style="text-align:center">


				<i class="material-icons dp48" @click="open_search()" >search</i>

		
		<!-- <ul class="sharing_list">
			<li id="fc_white"><a href="http://www.facebook.com/Hidabroot" target="_blank"></a></li>
			<li id="whatsapp_white"><a href="http://lp.vp4.me/b11r" target="_blank"></a></li>
			<li id="instagram_white"><a href="https://www.instagram.com/hidabroottv" target="_blank"></a></li>
			<li id="android_white"><a href="https://play.google.com/store/apps/details?id=net.linnovate.hidabroot" target="_blank"></a></li>
			<li id="itunes_white"><a href="https://itunes.apple.com/il/app/%D7%94%D7%99%D7%93%D7%91%D7%A8%D7%95%D7%AA/id1006747141?mt=8" target="_blank"></a></li>
		</ul> -->
	
		
		<ul>
      <li v-if="live.id > 0" class="btn_live" style="    color: #b71e58;font-size: 22px;font-weight: 800;text-align: center;"><router-link to="/live">שידור חי</router-link></li>
			<li v-for="menu_item in menu" :key="menu_item.id"  v-on:click.native="show_side_menu=false" ><router-link :to="'/'+ menu_item.link" v-on:click.native="show_side_menu=false"  :target="(menu_item.target != '' ? menu_item.target : '')" :style="(menu_item.color != '' ? 'color:#' + menu_item.color : '')"><span class="material-icons">{{menu_item.icon}}</span>{{ menu_item.name }}</router-link></li>
		</ul>


              <div id="mbl_user_menu">
                <ul>
                  <li><router-link to='/user/profiles' v-on:click.native="show_side_menu=false">נהל פרופילים</router-link></li>
                </ul>
                
                <div style="border-bottom:1px solid #333;"></div>

                <ul>
                  <li><router-link to='/user' v-on:click.native="show_side_menu=false">ניהול חשבון</router-link></li>
                  
                  <li><a @click="logout()">יציאה מ-TovTv</a></li>
                   <li v-if="!user_data.is_active"  @click="show_payment = true;show_side_menu=false" style="color: #b71e58;font-weight: 600;text-align: center;font-size: 18px;padding: 10px 0;">שדרוג למנוי פרימים</li>
                </ul>
                
              </div>

    </div>

    <main id="page-wrap" :class="(show_login || show_profile || $route.matched[0].props.default.header === false ? 'no_header' : '')">

      <div id="menu_hamburger"  v-if="is_mobile()" v-on:click="show_side_menu=!show_side_menu">
        <div id="nav-icon3"><span></span><span></span><span></span><span></span></div>
      </div>

      <TovHeader @open_pay="show_payment=true" :class="header_class" v-if="!show_login && $route.matched[0].props.default.header !== false" :live="live" :user_data="user_data" :profile="profile" :menu="menu"  @open_search="open_search()" />
      <div id="page_content" v-if="general_loaded">
        <LoginPage v-if="show_login" />
         
      <Loginprofile v-if="show_profile && fromnews != 'news'" :user_data="user_data" :profile="profile" :menu="menu"  />
  
        <router-view v-if="!show_login && !show_profile" :key="$route.path" :user_data="user_data" :profile="profile" :country_code="country_code" @show_loader="loaded=false" @loaded="loaded=true" @open_pay="show_payment=true"></router-view>
      </div>
      <!-- <TovFooter v-if="$route.matched[0].props.default.footer !== false" :menu="menu_footer" /> -->
      <SearchPage v-show="show_search" @closesearch="show_search = false ;show_side_menu=false" ref="search_page_el" />
      
      <!--
      <link href="https://cdn.jsdelivr.net/npm/animate.css@3.5.1" rel="stylesheet" type="text/css">
      <transition
    name="custom-classes-transition" 
    enter-active-class="animated tada"
    leave-active-class="animated bounceOutRight"
  >
  -->
  <Pay v-if="show_payment" @close="show_payment=false" />
  
  <!-- </transition> -->
    </main>
 
   
    <div v-if="!loaded" id="app_loading">
      <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
    </div>
    
  <div>
   

  </div>


  </div>
</template> 

<script> 
import Loginprofile from './components/login_profile.vue'
import TovHeader from './components/header.vue'
import Pay from './components/pay.vue'
// import TovFooter from './components/footer.vue'
import SearchPage from './components/search.vue'
import LoginPage from './components/login.vue'


window.api_url = 'https://podcastapi.tov.tv/api/'; 

export default {
  name: 'app',
  components: {
    'Loginprofile': Loginprofile,
    'TovHeader': TovHeader,
    // 'TovFooter': TovFooter,
    'SearchPage': SearchPage,
    'LoginPage': LoginPage,
    'Pay': Pay,

  },
  data(){
    return {
      show_payment: false,
      show_search: false,
      header_class: '',
      user_data: {},
      profile: {},
      country_code: '',
      live: [],
      menu: [],
      menu_footer: [],
      show_side_menu: false,
      show_login: false,
      show_profile: false,
      show_setup_popup: false,
      loaded: false,
      general_loaded: false,
       user_token: localStorage.getItem('user_token'),
      fromnews: this.$route.params.news,
      //  prevRoute: this.$router.go(-1),
       prevRoute: `${this.$route.params.prevpage}?t=`,
    }
    
  },
  methods: {
 
    check_header_fix(){
     // alert(4)
     if ( document.querySelector('#app').scrollTop > 95)
     {
       this.header_class = 'active'
     }
     else
     {
       this.header_class = ''
     }
    },

    open_search()
    {
      this.show_search = true;
      this.$refs['search_page_el'].reset(); 

       
    }
  },
  mounted(){
      let enable = document.createElement('script')
      enable.setAttribute('src', 'https://cdn.enable.co.il/licenses/enable-L10110gp640ny12e-1221-31350/init.js')
      document.head.appendChild(enable)
    window.app = this;
    if (!this.isNull(this.$route.query.login_token) && this.$route.query.login_token != '')
    {
      localStorage.setItem('user_token', this.$route.query.login_token);
      document.location = '/';
    }

    var self = this;

    // categories 
    this.api_call({ url: 'general', data: { is_profile_valid: !self.isNull(window.sessionStorage.getItem('profile_id')) }, onComplete: function(data){

      self.live = data.data.data.live
      self.user_data = data.data.data.user;
      self.country_code = data.data.data.country_code;
      self.menu = data.data.data.menu;
      self.menu_footer = data.data.data.footer;
      if (!self.isNull(data.data.data.profile)) self.profile = data.data.data.profile;

      self.$store.user = self.user_data;
      self.$store.state.profiles = self.user_data.profiles;
      self.$store.state.restrictions = data.data.data.restrictions;
      self.$store.state.restrictions_plans = data.data.data.restrictions_plans;
      self.$store.state.stickers = data.data.data.stickers;

      if (!(self.user_data.id > 0))
      {
        //self.$router.push("login");
        self.show_login = true;
      }
      // If logged and not choosed profile yet
      else if(self.isNull(data.data.data.profile) || !(data.data.data.profile.id > 0))
      {
        self.show_profile = true;

        if(self.fromnews === "news")
        {
            document.location = 'https://news.tov.tv/'+ self.prevRoute + self.user_token;
        }
      }
      // If logged and choose profile
      else 
      {
          if (self.$route.path.search('/set_up') === -1 && self.profile.has_perms == '1' && self.profile.new_setup == '0')
          { 
              document.location = '/set_up/' + self.profile.id
          }
           if(self.user_data.coupon == 20 && self.user_data.coupon_confirm == 0)
          {
              self.$fire({
                  title: "מנויים יקרים,מזמינים אתכם להמשיך להנות מהסרטים וסדרות מבוקרים לילדים מבוגרים ונוער. החל מהחודש השני מחיר המנוי יהיה 29.90. ניתן להתנתק בכל עת דרך האזור האישי",     
                  type: "success",
                });
                self.api_call({ url: 'coupon_confirm', data: { id : self.id}, onComplete: function(){ }});
          }
           if(self.fromnews === "news")
           {
              document.location = 'https://news.tov.tv/'+ self.prevRoute + self.user_token;
            }
      }
     
      

      self.loaded = true;
      self.general_loaded = true;

    } } );

  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css?family=Assistant:200,300,400,600,700,800&display=swap&subset=hebrew');
@import url('https://fonts.googleapis.com/icon?family=Material+Icons');

</style>
